export default {
  heading: 'Thank you for using Cheerie!',
  reinstall: 'Reinstall Extension',
  help: 'Help us improve!',
  question: 'Why did you uninstall Cheerie? Check all that apply.',
  improve: 'How can we improve Cheerie?',
  selectReason: 'Please select at least one reason',
  thanks: 'Thank you for your feedback!',
};
